<template>
  <BaseVeeForm :action="unsubscribe" @success="onUnsubscribed">
    <!-- formProps
      isIdle, isPending, isResolved, isRejected, invalid
      errors, submit
    -->
    <template #default="formProps">
      <BaseButton primary outline small :disabled="formProps.isPending">
        Unsubscribe<span class="sr-only">, {{ subscription.contact.full_name }}</span>
      </BaseButton>
    </template>
  </BaseVeeForm>
</template>

<script>
import { activeSubscriptionsClient } from '@/api/clients';

export default {
  props: {
    subscription: {
      type: Object,
      required: true,
    },
  },
  methods: {
    unsubscribe() {
      return activeSubscriptionsClient.destroy(this.subscription.id);
    },
    onUnsubscribed() {
      this.$emit('unsubscribed');
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: {
          unsubscribed: new Date().getTime(),
        },
      });
    },
  },
};
</script>
